import { Stack, useTheme } from "@mui/material";
import React from "react";
import { FabExtend, InputBusca } from "../../../components";

function UsersPagePanel({
  filter,
  setFilter,
  onAdd,
  color,
  icon,
  title,
  label,
}) {
  const isMobile = useTheme()?.isMobile;

  return (
    <Stack direction="row" gap={isMobile ? 0 : 1.5} alignItems="center">
      <InputBusca
        fullWidth
        sx={{ mb: 1 }}
        variant="filled"
        label=""
        filtro={filter}
        setFiltro={setFilter}
        desativarPesquisaLenta
      />
      <FabExtend
        icone={icon}
        color={color}
        title={title}
        text={label}
        onClick={onAdd}
      />
    </Stack>
  );
}

export default UsersPagePanel;
